import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Container,
  KeyboardView,
  Wrapper,
  Copy,
  Title,
  Button,
  Row,
  Icon
} from "app/NativeComponents/common";

import PaymentPage from "./PaymentPage";

import {
  /*mobile*/
  appRedirect,
  loadSignUpOnboarding
} from "app/NativeActions";

class ConfirmPayment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onboarding_content: null,
      onboarding_content_loading: true
    };
  }

  componentDidUpdate(prevProps) {}

  componentDidMount() {
    this.getOnboardingData();
  }

  getOnboardingData() {
    loadSignUpOnboarding("new_onboarding")
      .then(data => {
        if (data && data.items && data.items.length > 0) {
          this.setState(() => ({
            onboarding_content: data.items[0]
              ? data.items[0].fields
                ? data.items[0].fields
                : null
              : null,
            onboarding_content_loading: false
          }));
        }
        this.setState(() => ({ onboarding_content_loading: false }));
      })
      .catch(err => {
        this.setState(() => ({ onboarding_content_loading: false }));
      });
  }

  render() {
    const { payment_page, isMobile } = this.props;
    const { onboarding_content } = this.state;
    if (payment_page && onboarding_content) {
      return (
        <Container>
          <KeyboardView style={{ maxWidth: 900 }}>
            <Row
              style={{
                paddingTop: this.props.isMobile ? 60 : 40,
                alignItems: "space-between",
                justifyContent: "center"
              }}
            >
              <Wrapper style={{ flex: 1, paddingLeft: 20 }}>
                <Button
                  onPress={() => {
                    this.props.appRedirect({
                      redirect: "onboardingSelectPlans"
                    });
                  }}
                >
                  <Row>
                    <Icon
                      icon="arrow-back"
                      size={this.props.isMobile ? 26 : 18}
                      style={{ marginRight: 5 }}
                    />
                    {!this.props.isMobile ? <Copy>Change Options</Copy> : null}
                  </Row>
                </Button>
              </Wrapper>
              <Wrapper style={{ flex: 2 }}>
                <Copy style={{ textAlign: "center" }}>5 of 5</Copy>
              </Wrapper>
              <Wrapper style={{ flex: 1 }} />
            </Row>
            <Wrapper
              style={{
                alignItems: "center",
                justifyContent: "center",
                padding: 40
              }}
            >
              <Title style={{ textAlign: "center", marginBottom: 10 }}>
                {onboarding_content.billingInfoTitle}
              </Title>
              <Copy style={{ textAlign: "center" }}>
                {onboarding_content.billingInfoDescription}
              </Copy>
            </Wrapper>
            <PaymentPage
              engine_slug={payment_page.engine_slug}
              tier={payment_page.tier}
              frequency={payment_page.frequency}
              extra_fee={payment_page.extra_fee}
              extra_fee_text={payment_page.extra_fee_text}
            />
          </KeyboardView>
        </Container>
      );
    }
    return null;
  }
}

const mapStateToProps = ({ auth, native, settings, billing }) => {
  const { token, user } = auth;
  const { colors } = settings;
  const { device, isMobile } = native;
  const { card, payment_page } = billing;
  return {
    token,
    user,
    device,
    isMobile,
    card,
    colors,
    payment_page
  };
};

export default connect(mapStateToProps, {
  /*mobile*/
  appRedirect
})(ConfirmPayment);
